class ShipTo {
  constructor({
    id,
    attributes: {
      attention_to,
      street,
      city,
      state,
      country,
      zipcode,
      createdAt,
      updatedAt,
    },
  }) {
    this.id = id;
    this.attentionTo = attention_to;
    this.street = street;
    this.city = city;
    this.state = state;
    this.country = country;
    this.zipcode = zipcode;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }
}

export default ShipTo;
